<template>
  <div class="theme-garden-item" @mouseout="ctaExit" @mouseover="ctaHover">
    <div class="preview">
      <img :src="previewImage()" :alt="name">
      <div class="actions" :class="{hover: itemHover}">
        <md-button class="md-button md-raised md-primary md-theme-default"
                   @click="previewTheme()"
        >{{ $t(`sitebuilder_templates.THEME_GARDEN_ACTION_PREVIEW`) }}
        </md-button>

        <md-button class="md-button md-raised md-primary md-theme-default bn-primary"
                   @click="useTheme()"
        >{{ $t(`sitebuilder_templates.THEME_GARDEN_ACTION_USE`) }}
        </md-button>

      </div>
    </div>
    <div class="title" v-html="item.name"></div>
  </div>
</template>

<script>
import style from 'styles/themes-garden.scss'
import login from 'brave-authentication/components/login'
import ThemePreviewModal from "./theme-preview-modal";

export default {
  components: {ThemePreviewModal},
  props: {
    id: Number,
    name: String,
    createdAt: String,
    item: Object,
  },

  data: () => ({
    itemHover: false
  }),
  methods: {
    previewImage() {
      const api_url = (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging')
          ? '//jigsy.com'
          : '//jigsy.com';

      return `${api_url}/template/screenshot/${this.id}`
    },
    useTheme() {
      this.$router.push({
        path: '/register',
        query: {
          from: 'bravesites', template_id: this.id
        }
      });
    },
    previewTheme() {
      let preview_url = this.item['preview_url']
          ? this.item['preview_url'].replace('http://', 'https://')
          : 'https://plainsite.siteblocks.com';

      this.$store.dispatch('pushModal', {
        component: ThemePreviewModal, // Use the imported component
        props: {
          id: this.item['id'], // Pass the previewUrl prop
          previewUrl: preview_url, // Pass the previewUrl prop
        }
      });
    },
    ctaHover() {
      this.itemHover = true
    },
    ctaExit() {
      this.itemHover = false
    },
    updateWindowDimensions() {
      // Calculate window width and height
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      // Update CSS variables
      document.documentElement.style.setProperty('--window-width', windowWidth + 'px');
      document.documentElement.style.setProperty('--window-height', windowHeight + 'px');
    },
  },
  mounted() {
    // Call the function when the component is mounted and whenever the window is resized
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  },
  beforeDestroy() {
    // Remove the event listener when the component is destroyed
    document.documentElement.style.removeProperty('--window-width');
    document.documentElement.style.removeProperty('--window-height');
    window.removeEventListener('resize', this.updateWindowDimensions);
    this.$store.dispatch('popModal');
  }
}
</script>
<style lang="scss">
[data-section="sitebuilder"] {
  .modal-wrapper {
    max-height:100% !important;
    overflow-y: unset !important;
    padding-top: 0px !important;
    padding-left: 0px !important;
    padding-bottom: 0px !important;
    padding-right: 0px !important;
    display: block;
  }

  .modal-container {
    --padding-x: 4;
    --padding-y: 2;
    //width: calc(var(--window-width) - (var(--padding-y) * 1vw));
    //height: calc(var(--window-height) - (var(--padding-x) * 1vh));
    width: calc(var(--window-width) - 15px);
    height: calc(var(--window-height) - 20px);
    max-width: inherit;
    padding: 0 !important;
    margin-top: 10px;
  }
}
</style>

<style scoped>
.loading-preview-item {
  width: 500px;
  max-width: 500px;
  max-height: 375px;
  height: 375px;
}
</style>



// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/sitebuilder/theme-item.vue